import Icon from "@ch/components/Icons/Icon";
import { HealthPassportPathsEnum } from "@ch/router/HealthPassportRoutes/enums";
import type { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
  bgColor: string;
  iconBg: ReactNode;
  title: string;
}

const SingleHealthPassportTopCard: FC<IProps> = ({
  bgColor,
  iconBg,
  title,
}) => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        className={`relative overflow-hidden ${bgColor} z-0 !h-[125px] rounded-xl`}
      >
        <div className="absolute -bottom-10 right-5 text-gray-200 opacity-30">
          {iconBg}
        </div>
        <div className="flex h-full flex-col justify-between p-5">
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <button
            className="flex cursor-pointer items-center gap-2 text-white"
            onClick={() => {
              void navigate(`/${HealthPassportPathsEnum.ROOT}`);
            }}
            type="button"
          >
            <div className="rounded-full p-1 transition-all duration-300 hover:bg-gray-300/50">
              <Icon name="back-arrow" size={20} />
            </div>
            <span>History</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleHealthPassportTopCard;
